import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { FirestoreBase } from '../../core/db/firestore-base';
import { ShippingLabel } from './shipping-label.models';

/**
 * ShippingLabel Firestore data-access service.
 * Extends {@link FirestoreBase} to reuse generic CRUD and query helpers.
 * Use inherited methods such as `get$`, `getOneWhere$`, `create`, `upsert`, and `update`
 * from higher layers (`shipping-label.service`) unless a shipping label-specific query is required.
 */
@Injectable({ providedIn: 'root' })
export class ShippingLabelDbService extends FirestoreBase<ShippingLabel> {
  constructor(firestore: Firestore) {
    super(
      'shippingLabels',
      firestore
    );
  }

}
